<template>
  <div class="content-box">
    <div class="colse-btn" @click="closeDia">&Cross;</div>
    <div class="content-wrap">
      <div class="title">1111111111111111111111</div>
      <div class="content">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goods: Object
  },
  components: {

  },
  data() {
    return {

    };
  },
  methods: {
    // 关闭弹窗
    closeDia() {
      this.$emit("handleClose", false);
    },
    // 菜单切换
    menuActive(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
.content-box {
  background: #062349;
  // padding: 0.2rem;
  width: 8rem;
  height: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  .colse-btn {
    border-radius: 50%;
    border: 1px solid rgb(0, 205, 252, 0.8);
    font-size: 0.16rem;
    width: 0.2rem;
    height: 0.2rem;
    text-align: center;
    line-height: 0.16rem;
    color: #fff;
    float: right;
    margin: 0.05rem;
    cursor: pointer;
  }
  .content-wrap {
    border: 1px solid #00cdfc;
    //margin: 0.5rem 0.3rem;
    padding: 0.1rem;
    height: 4rem;
    .title {
      font-size: 0.1rem;
      background: linear-gradient(to bottom, #d0fdff, #56f7ff);
      background-clip: text;
      color: transparent;
      text-align: center;
      border-bottom: 3px solid;
      border-image: -webkit-linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 0%,
              #00bbf2 20%,
              rgba(255, 255, 255, 0) 99%
      )
      2 2 2 2;
      border-image: -moz-linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 0%,
              #00bbf2 20%,
              rgba(255, 255, 255, 0) 99%
      )
      2 2 2 2;
      border-image: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 0%,
              #00bbf2 20%,
              rgba(255, 255, 255, 0) 99%
      )
      2 2 2 2;
      width: 15%;
      padding: 0.1rem;
      margin: 0 auto;
    }
    .content {
      display: flex;
      //   align-items: center;
      margin-top: 0.1rem;
      font-size: 0.1rem;

    }
  }
}
@media screen and (max-width: 1920px) {
  .content-box {

  }
}
</style>
